import React from "react";
import WorkingHours from "./WorkingHours";

const index = ({ operations }) => {
  const workingHoursArray = [];
  const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

  for (let index = 0; index < days.length; index++) {
    if (operations[days[index]]) {
      workingHoursArray.push(
        <WorkingHours
          key={index}
          day={days[index]}
          from={operations[days[index]].from}
          to={operations[days[index]].to}
          close={false}
        />
      );
    } else {
      workingHoursArray.push(<WorkingHours key={days[index]} day={days[index]} close />);
    }
  }

  return workingHoursArray;
};

export default index;



// WEBPACK FOOTER //
// ./components/ServiceBottom/WorkingHoursContainer/index.js